import { CHATBOT_NAME } from "../../../../../features/ai-chatbot/constants/chatbot-name.const";
import type { UseChatbotPlaceholderParams } from "./use-chatbot-placeholder.interface";

export function useChatbotPlaceholder({ messages }: Readonly<UseChatbotPlaceholderParams>) {
  const zeroMessagesInChat = !messages || messages.length === 0;

  if (zeroMessagesInChat) {
    return `Chiedi a ${CHATBOT_NAME}`;
  }

  return `Rispondi a ${CHATBOT_NAME}`;
}
